import { Box } from '@mui/material';
import { useRef, useState, useEffect } from 'react';

const StakeInput = ({ value = 50, onChange }) => {
	const [isEditable, setIsEditable] = useState(false);
	const inputRef = useRef();

	// Format number with commas (whole numbers only)
	const formatNumber = (num) => {
		if (!num && num !== 0) return '';
		const numStr = String(Math.round(parseFloat(num) || 0));
		return numStr.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
	};

	// Focus input when entering edit mode
	useEffect(() => {
		if (isEditable && inputRef.current) {
			const timer = setTimeout(() => {
				if (inputRef.current) {
					inputRef.current.focus();
				}
			}, 10);
			return () => clearTimeout(timer);
		}
	}, [isEditable]);

	const handleChange = (e) => {
		const inputValue = e.target.value;
		// Remove commas and other non-numeric characters (only whole numbers)
		let val = inputValue.replace(/[^0-9]/g, '');
		// Round to whole number
		if (val) {
			val = Math.round(parseFloat(val) || 0);
		}
		onChange?.(val);
	};

	return (
		<>
			{!isEditable ? (
				<Box
					onClick={() => setIsEditable(true)}
					sx={{
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						paddingTop: '8px',
						paddingBottom: '8px',
						paddingLeft: '10px',
						paddingRight: '10px',
						borderRadius: '1rem',
						backgroundColor: '#22262e',
						cursor: 'pointer',
						transition: 'all 0.2s',
						width: '140px',
						minWidth: '140px',
						marginLeft: '10px',
						border: '1px solid transparent',
						'&:hover': {
							backgroundColor: '#2a2e36',
							borderColor: '#4a5568',
						},
					}}
					title="Click to edit stake">
					<span style={{ color: 'white', fontSize: '18px', fontWeight: 600, textAlign: 'center' }}>${formatNumber(value || 0)}</span>
				</Box>
			) : (
				<Box
					sx={{
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						paddingTop: '8px',
						paddingBottom: '8px',
						paddingLeft: '10px',
						paddingRight: '10px',
						borderRadius: '1rem',
						backgroundColor: '#22262e',
						width: '140px',
						minWidth: '140px',
						marginLeft: '10px',
						border: '1px solid #4a5568',
					}}>
					<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
						<span style={{ color: 'white', fontSize: '18px', fontWeight: 600, marginRight: '4px' }}>$</span>
						<input
							type="text"
							inputMode="numeric"
							style={{
								border: 'none',
								outline: 'none',
								backgroundColor: 'transparent',
								color: 'white',
								fontSize: '18px',
								fontWeight: 600,
								width: '80px',
								padding: 0,
								pointerEvents: 'auto',
								textAlign: 'center',
							}}
							value={formatNumber(value || '')}
							onChange={handleChange}
							onBlur={() => setIsEditable(false)}
							onKeyDown={(e) => {
								if (e.key === 'Enter') {
									e.target.blur();
								}
							}}
							ref={inputRef}
							autoComplete="off"
						/>
					</div>
				</Box>
			)}
		</>
	);
};

export default StakeInput;
